// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class CancelFactoryOrderAction implements flatbuffers.IUnpackableObject<CancelFactoryOrderActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):CancelFactoryOrderAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsCancelFactoryOrderAction(bb:flatbuffers.ByteBuffer, obj?:CancelFactoryOrderAction):CancelFactoryOrderAction {
  return (obj || new CancelFactoryOrderAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsCancelFactoryOrderAction(bb:flatbuffers.ByteBuffer, obj?:CancelFactoryOrderAction):CancelFactoryOrderAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new CancelFactoryOrderAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GameCancelFactoryOrder;
}

factoryId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

static startCancelFactoryOrderAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GameCancelFactoryOrder);
}

static addFactoryId(builder:flatbuffers.Builder, factoryId:number) {
  builder.addFieldInt32(1, factoryId, 0);
}

static endCancelFactoryOrderAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createCancelFactoryOrderAction(builder:flatbuffers.Builder, type:ActionType, factoryId:number):flatbuffers.Offset {
  CancelFactoryOrderAction.startCancelFactoryOrderAction(builder);
  CancelFactoryOrderAction.addType(builder, type);
  CancelFactoryOrderAction.addFactoryId(builder, factoryId);
  return CancelFactoryOrderAction.endCancelFactoryOrderAction(builder);
}

unpack(): CancelFactoryOrderActionT {
  return new CancelFactoryOrderActionT(
    this.type(),
    this.factoryId()
  );
}


unpackTo(_o: CancelFactoryOrderActionT): void {
  _o.type = this.type();
  _o.factoryId = this.factoryId();
}
}

export class CancelFactoryOrderActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GameCancelFactoryOrder,
  public factoryId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return CancelFactoryOrderAction.createCancelFactoryOrderAction(builder,
    this.type,
    this.factoryId
  );
}
}
